module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box_header"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Thêm mới lý thuyết " + _vm._s(_vm.lesson_id))])])]), _c('div', {
    staticClass: "box_content lesson"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "margin": "0"
    }
  }, [(_vm.error) ? _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()]), _c('div', {
    staticClass: "form-group col-md-6",
    class: _vm.errorArray
  }, [_c('label', {
    staticClass: "control-label text-md-right",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Tên lý thuyết *")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "name": "title",
      "required": "required",
      "autofocus": "autofocus",
      "placeholder": "Tên lý thuyết"
    }
  })]), _c('div', {
    staticClass: "form-group col-md-6",
    class: _vm.errorArray
  }, [_c('label', {
    staticClass: "control-label text-md-right",
    attrs: {
      "for": "categorys"
    }
  }, [_vm._v("Danh mục bài học *")]), _c('itemCategory', {
    attrs: {
      "category": _vm.category
    },
    on: {
      "onCategoryChange": _vm.onCategoryChange
    }
  })], 1), _c('div', {
    staticClass: "form-group col-md-6",
    class: _vm.errorArray
  }, [_c('label', {
    staticClass: "control-label text-md-right",
    attrs: {
      "for": "subjects"
    }
  }, [_vm._v("Chọn môn học *")]), _c('itemSubject', {
    attrs: {
      "subjects": _vm.subjects
    },
    on: {
      "onSubjectChange": _vm.onSubjectChange
    }
  })], 1), _c('div', {
    staticClass: "form-group col-md-6",
    class: _vm.errorArray
  }, [_c('label', {
    staticClass: "control-label text-md-right",
    attrs: {
      "for": "grades"
    }
  }, [_vm._v("Chọn khối lớp *")]), _c('itemGrade', {
    attrs: {
      "grades": _vm.grades
    },
    on: {
      "onGradeChange": _vm.onGradeChange
    }
  })], 1), _c('div', {
    staticClass: "form-group",
    class: _vm.errorArray
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label text-md-right",
    attrs: {
      "for": "content"
    }
  }, [_vm._v("Nội dung lý thuyết")]), _c('froala', {
    attrs: {
      "tag": 'textarea',
      "config": _vm.config
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1)]), _c('div', {
    staticClass: "form-group",
    class: _vm.errorArray
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box-images"
  }, [_vm._m(0), _c('div', {
    attrs: {
      "id": "list_banner"
    }
  }), _vm._l((_vm.lstBanners), function(banner, index) {
    return (banner) ? _c('div', {
      staticClass: "box-item"
    }, [_c('span', {
      staticClass: "material-icons",
      on: {
        "click": function($event) {
          return _vm.deleteBanner(index)
        }
      }
    }, [_vm._v("highlight_off")]), _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": banner.src
      }
    })]) : _vm._e()
  }), _c('div', {
    staticClass: "box-item last"
  }, [_c('input', {
    attrs: {
      "id": "banner",
      "name": "banner",
      "type": "file",
      "accept": "image/*",
      "multiple": "multiple"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._m(1)])], 2), _c('div', {
    staticClass: "clearfix"
  })]), _vm._m(2), _vm._m(3), _c('div', {
    staticClass: "form-group",
    class: _vm.errorArray
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-active",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitLesson
    }
  }, [_vm._v("Thêm mới")]), _c('button', {
    staticClass: "btn btn-rest",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.lessonList
    }
  }, [_vm._v("Huỷ yêu cầu")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label text-md-right",
    attrs: {
      "for": "content"
    }
  }, [_c('strong', [_vm._v("Ảnh banner : "), _c('span', [_vm._v("(Kích thước đề nghị: 680x260 px)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "material-icons list-action"
  }, [_vm._v("add")]), _c('strong', [_vm._v("Tải ảnh lên")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "attach"
  }, [_c('strong', [_vm._v("File đính kèm")])]), _c('div', {
    staticClass: "box-attach"
  }, [_c('div', {
    staticClass: "box-selected-file"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "name": "files[]",
      "multiple": "multiple"
    }
  }), _c('span', [_vm._v("Chọn file")]), _c('label', {
    staticClass: "files"
  }, [_vm._v("Chọn 2 files")])]), _c('div', {
    staticClass: "box-item-attach"
  }, [_c('label', [_c('i', {
    staticClass: "fa fa-paperclip"
  }), _c('span', [_vm._v("Tenfile.docx")]), _c('span', {
    staticClass: "material-icons remove"
  }, [_vm._v("delete")])])]), _c('div', {
    staticClass: "box-item-attach"
  }, [_c('label', [_c('i', {
    staticClass: "fa fa-paperclip"
  }), _c('span', [_vm._v("Tenfile.docx")]), _c('span', {
    staticClass: "material-icons remove"
  }, [_vm._v("delete")])])]), _c('div', {
    staticClass: "box-item-attach"
  }, [_c('label', [_c('i', {
    staticClass: "fa fa-paperclip"
  }), _c('span', [_vm._v("Tenfile.docx")]), _c('span', {
    staticClass: "material-icons remove"
  }, [_vm._v("delete")])])])]), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "attach"
  }, [_c('strong', [_vm._v("Chia sẻ lý thuyết *")])]), _c('div', {
    staticClass: "box-attach theory"
  }, [_c('div', {
    staticClass: "box-selected-file"
  }, [_c('p', [_c('input', {
    attrs: {
      "type": "radio",
      "id": "theory1",
      "name": "theory",
      "checked": "checked"
    }
  }), _c('label', {
    attrs: {
      "for": "theory1"
    }
  }, [_vm._v("Nội dung chưa sẵn sàng hiển thị")])]), _c('p', [_c('input', {
    attrs: {
      "type": "radio",
      "id": "theory2",
      "name": "theory"
    }
  }), _c('label', {
    attrs: {
      "for": "theory2"
    }
  }, [_vm._v("Public toàn hệ thống và các lớp học của tôi")])]), _c('p', [_c('input', {
    attrs: {
      "type": "radio",
      "id": "theory3",
      "name": "theory"
    }
  }), _c('label', {
    attrs: {
      "for": "theory3"
    }
  }, [_vm._v("Chỉ hiển thị trong PC "), _c('strong', [_vm._v("Tên PC có môn học trùng")]), _vm._v(" của tôi")]), _c('select', {
    staticClass: "select-pc",
    attrs: {
      "id": "pc",
      "name": "pc"
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Chọn lớp học muốn chia sẻ trong PC")])])])]), _c('div', {
    staticClass: "box-item-attach"
  }, [_c('label', [_c('i', {
    staticClass: "fa fa-users"
  }), _c('span', [_vm._v("Lớp 6a7 - Hoá học chiều thứ 5")]), _c('span', {
    staticClass: "material-icons remove"
  }, [_vm._v("delete")])])]), _c('div', {
    staticClass: "box-item-attach"
  }, [_c('label', [_c('i', {
    staticClass: "fa fa-users"
  }), _c('span', [_vm._v("Lớp 9a9 Hoá học nâng cao")]), _c('span', {
    staticClass: "material-icons remove"
  }, [_vm._v("delete")])])]), _c('div', {
    staticClass: "box-item-attach"
  }, [_c('label', [_c('i', {
    staticClass: "fa fa-users"
  }), _c('span', [_vm._v("Lớp 9a9 Hoá học nâng cao")]), _c('span', {
    staticClass: "material-icons remove"
  }, [_vm._v("delete")])])])]), _c('div', {
    staticClass: "clearfix"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c05a184","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lesson/view.vue
// module id = 1499
// module chunks = 0